import p2_img1 from '../Assets/p2_img1.webp'
import p3_img1 from '../Assets/p3_img1.webp'
import p4_img1 from '../Assets/p4_img1.avif'
import p7_img1 from '../Assets/p7_img1.webp'


let data_product= [
          {
        id: 2,
        category: "women",
        name: "Silk Blend Saree with Golden Zari Work and Modern Floral Patterns",
        image: p2_img1, 
        new_price: 10950.00,
        old_price: 12900.00,
        star: 5,
        reviews: 85,
        description: `
    This luxurious silk blend saree is crafted from a smooth and lustrous fabric that combines silk and cotton for the perfect balance of elegance and comfort. The saree is adorned with golden zari work that glimmers subtly under light, enhancing the richness of the fabric. Modern floral patterns are integrated throughout, giving the saree a contemporary aesthetic while retaining traditional charm.
    
    The saree's lightweight nature makes it easy to drape, allowing for graceful movement throughout the day. The fabric’s softness feels gentle on the skin, while the delicate weaving ensures durability and long-lasting use. Each pattern and zari accent is carefully placed to create a harmonious design that draws attention without overwhelming the senses.
    
    Ideal for weddings, festive events, and evening functions, this saree can be paired with statement jewelry to complete a regal look or with minimal accessories for a modern, sophisticated appearance. Its versatility and timeless design make it a staple for women who appreciate both tradition and modern fashion trends.`
      },
      {
        id: 3,
        category: "men",
        name: "Tailored Linen Shirt with Hand-Embroidered Accents for Casual and Formal Occasions",
        image: p3_img1,
        new_price: 3650.00,
        old_price: 4500.00,
        star: 4,
        reviews: 70,
        description: `
    This premium linen shirt is crafted from high-quality, breathable linen, offering exceptional comfort and a crisp appearance throughout the day. The shirt features subtle hand-embroidered accents along the chest and sleeves, adding a refined touch that elevates its overall design. Its tailored fit ensures a flattering silhouette suitable for a range of occasions.
    
    The lightweight fabric allows for excellent air circulation, keeping you cool in warm weather, while the durable stitching ensures the shirt maintains its structure over time. The buttons are carefully chosen to complement the fabric and embroidery, providing a seamless and polished finish.
    
    Perfect for both casual outings and semi-formal events, this shirt can be paired with tailored trousers for a formal look or with jeans for a relaxed, stylish ensemble. Its versatility and attention to detail make it a must-have for men who appreciate both craftsmanship and contemporary fashion.`
      },
      {
        id: 4,
        category: "women",
        name: "Chiffon Long Dress with Flowing Silhouette and Vibrant Floral Prints",
        image: p4_img1,
        new_price: 5800.00,
        old_price: 7200.00,
        star: 3,
        reviews: 45,
        description: `
    This elegant chiffon long dress features a flowing silhouette that moves gracefully with every step. The vibrant floral prints bring a touch of freshness and playfulness, making it ideal for spring and summer outings. The lightweight chiffon fabric ensures breathability and comfort, even during long wear.
    
    The dress is designed with attention to detail, including subtle pleats and a defined waistline that enhances the overall fit. The soft lining provides additional comfort and prevents transparency, allowing you to wear it confidently. Its versatile design allows for both casual and semi-formal styling.
    
    Perfect for brunches, garden parties, or evening events, this dress can be paired with strappy sandals or heels and minimal accessories for a chic, effortless look. Its timeless elegance and comfortable design make it a wardrobe essential for modern women.`
      },
      {
    id: 7,
    name: "Premium Cotton Shirt with Classic Collar and Slim Fit",
    image: p7_img1,
    new_price: 4200.00,
    old_price: 5000.00,
    star: 4,
    reviews: 60,
},
]
export default data_product